/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateStoredValueBalanceRequest} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateStoredValueBalance.pb'
import {CreateStoredValueBalanceResponse} from '@cash-web/protos/squareup/cash/lynx/api/v1_0/CreateStoredValueBalance.pb'


export const createStoredValueBalance = (request: CreateStoredValueBalanceRequest, options?: CashRequestOptions) => post<CreateStoredValueBalanceRequest, CreateStoredValueBalanceResponse>("/2.0/cash/create-stored-value-balance", request, {...options, rejectOnError: true })